/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTieredChargeTable.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/tiered-charge-table";

export class AutogenModelTieredChargeTable<RowType extends ModelRow> extends Endpoint<RowType, RowTieredChargeTableFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTieredChargeTable extends ModelRow<RowTieredChargeTableFields> {
	constructor(values?: Partial<RowTieredChargeTableFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTieredChargeTableFields {
	company_id: string;
	currency_type: string;
	descr: string;
	is_active: string;
	table_id: string;
}

